import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSuccessAlt = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 25, cy: 25, r: 25, fill: "#000" }), /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "#fff", strokeWidth: 4, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, d: "M38 15 22 33l-10-8" }));
const ForwardRef = forwardRef(SvgSuccessAlt);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
